import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { WheelProvider } from './context/WheelContext';
import { useEffect } from 'react';
import { useWheel } from './context/WheelContext';
import Wheel from './pages/Wheel';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';

function TitleUpdater() {
  const { isSharkMode } = useWheel();

  useEffect(() => {
    document.title = isSharkMode 
      ? 'Shark Roulette | Selección Aleatoria Shark Tank'
      : 'Ruleta Aleatoria | Selección Random de Participantes';

    const faviconICO = document.querySelector('link[rel="icon"][sizes="any"]');
    const faviconSVG = document.querySelector('link[rel="icon"][type="image/svg+xml"]');
    const appleTouchIcon = document.querySelector('link[rel="apple-touch-icon"]');

    if (isSharkMode) {
      faviconICO.href = '/favicon-shark.ico';
      faviconSVG.href = '/favicon-shark.svg';
      appleTouchIcon.href = '/apple-touch-icon-shark.png';
    } else {
      faviconICO.href = '/favicon.ico';
      faviconSVG.href = '/favicon.svg';
      appleTouchIcon.href = '/apple-touch-icon.png';
    }
  }, [isSharkMode]);

  return null;
}

function App() {
  return (
    <WheelProvider>
      <Router>
        <TitleUpdater />
        <Routes>
          <Route path="/" element={<Wheel />} />
          <Route path="/privacidad" element={<Privacy />} />
          <Route path="/terminos" element={<Terms />} />
        </Routes>
      </Router>
    </WheelProvider>
  );
}

export default App; 